import styled from 'styled-components';

import { Title } from 'ui/components/styled';

export const JobTitle = styled(Title)`
  font-weight: bold;
  font-size: 24px;
  letter-spacing: 0.04em;
  text-align: left;
  color: #333;
`;
